/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/**
 * 注册importNewFile事件，导入新文档
 * 默认file-menu-btn组件内注册监听
 * @author baishuzhao
 */
import ArkLoader from '@src/js/common/ark-extensions';
import { IMPORT_FILE } from '@src/js/common/ark-extensions/dc-components/import-file/component-config';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import i18n from '@i18next/i18n';
import { MIMETypeJSON } from '@framework/workbench/ui/titlebar/components/menu-bar/constants';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { getQuerySearchParams } from '@src/slide/infrastructure/module/independent/url/param-operation';
import { IImportNewFileManagerInjectable } from '@src/slide/application/service/import-file-manager/core/import-file-manager.interface';
export default class ImportNewFileManager {
    protected static logTag = 'ImportNewFile';
    private uiDataService: IUiDataService;
    private selectionService: ISelectionService;

    public constructor(private injectable: IImportNewFileManagerInjectable) {
        if (this.injectable.handleImportFileObject) {
            this.handleImportFileObject = this.injectable.handleImportFileObject.bind(this);
        }
    }

    public setUiDataServiceDelegate(uiDataService: IUiDataService): void {
        this.uiDataService = uiDataService;
    }

    public setSelectionServiceDelegate(selectionService: ISelectionService): void {
        this.selectionService = selectionService;
    }

    public handleImportFile = (files) => {
        this.checkImportContainer();
        const fileObj = files?.[0];
        if (!fileObj) return;

        this.handleImportFileObject(fileObj);
    };

    /**
     * 桌面端拖拽上传本地文件
     */
    public handleImportFileOnDesktopApp = (fileObj) => {
        const filePath = { path: getQuerySearchParams('localFilePath') };
        import(/* webpackChunkName: "service" */ '@tencent/docs-drive-api').then((module) => {
            const { driveApi } = module;
            driveApi.getLocalFile(filePath).then(() => {
                this.showImportDialog(fileObj);
            })
                .catch((error) => {
                    console.log('driveapi error: ', error);
                    Snackbar.show({
                        type: 'error',
                        duration: 5000,
                        message: i18n.t('本地文件不存在'),
                        autoClose: true,
                    });
                });
        });
    };

    // 导入文件
    public showImportDialog = async (file: File) => {
        const container = document.getElementById('import-file-container');
        if (container) {
            container.style.display = 'block';
        }
        window.log.info(`${ImportNewFileManager.logTag} ArkLoader getExtension import-file`);
        const importFileExtension = await ArkLoader.extensionService.getExtension(IMPORT_FILE.name);
        importFileExtension.show({
            file,
            container,
            supportNewUI: false,
        });
    };

    /**
     * Web 端拖拽上传本地文件
     */
    private handleImportFileObject(fileObj: any) {
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.error) {
                window.log.info(`${ImportNewFileManager.logTag} Error opening presentation`);
            } else {
                if (MIMETypeJSON === fileObj.type) {
                    // try {
                    //     this.uiDataService?.loadNewPresentation(reader.result);
                    //     if (this.selectionService) {
                    //         this.selectionService.currentSlideIndex = 0;
                    //     }
                    // } catch (e) {
                    //     window.log.error(e);
                    // }
                } else {
                    this.showImportDialog(fileObj);
                }
                window.log.info(`file = ${JSON.stringify(fileObj)}`);
            }
        };
        reader.readAsText(fileObj);
    }

    // 是否有存放导出组件的容器
    private checkImportContainer = () => {
        const container = document.querySelector('#import-file-container');
        if (!container) {
            const containerDom = document.createElement('div');
            containerDom.id = 'import-file-container';
            document.body.appendChild(containerDom);
        }
    };
}
